import { render, staticRenderFns } from "./index_copy.html?vue&type=template&id=32822a76&external"
import script from "./index_copy.vue?vue&type=script&lang=js"
export * from "./index_copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports